export function removeDuplicatesFromArray<T>(array: T[]) { // TODO: preferably use a set to do this instead. Might mess up the order though?
  const newArray: T[] = [];

  for (const item of array) {
    if (!newArray.includes(item)) {
      newArray.push(item);
    }
  }

  return newArray;
}
